export default Object.freeze({
  check_cookie_url: "https://api.fyers.in/api/v2/check-cookie",
  login_callback_url: `https://login.fyers.in/?cb=${window.location.origin}`,
  base_url: "https://api-t1.fyers.in/api/v2/user",
});
